<template>
    <div class="creatAccount">
        
        <div class="icon">
            <i class="el-icon-circle-check-outline"></i>
        </div>
        <p>
            <!-- {{$store.state.firstName}}, your TVU Search account ({{$store.state.email}}) is ready. Click below to SIGN IN NOW. -->
            This email is already in use, please click below to continue sign-in or reset your password
        </p>
        <div class="btn clearfix">
            <span class="f_l">
                <a @click="back">Back</a>
            </span>
            <el-button class="f_r" @click="link">Sign In</el-button>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
export default {
    props:{
        backBtn: Boolean
    },
    data(){
        return{
            activateInfo:{},
            rule:{}
        }
    },
    methods:{
        back(){
            gaAnalyze('lpRegistBack');
            this.$emit('showModule',{type:'back'})
        },
        link(){
            gaAnalyze('lpRegistSignIn');
            window.location.href = "http://" + window.location.host + '/userGroup/user-group/rgUser/redirectSignIn?service=1';
        }
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    font-size: .16rem;
    line-height: 0.20rem;
    margin-bottom: 0.30rem;
    a{
        color: #1EC345;
    }
}
.icon{
    text-align: center;
    margin-bottom: .30rem;
    i{
        color: #1EC345;
        font-size: .72rem;

    }
}
.btn{
    position: relative;
    a{
        color: #1EC345;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    margin-bottom: .6rem;
}
@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.2rem;
    }
}
</style>

